<template>
  <div id="app">
    <nav-bar></nav-bar>
    <router-view/>
  </div>
</template>

<script>
import Navbar from './components/SiteNav'
export default {
  components: {
    'nav-bar' : Navbar
  }
  
}
</script>

<style>

</style>
